/* eslint-disable no-console */
/* eslint-disable max-len */
import _ from 'lodash';

export let fullWindowHeightMixinBlock = {
	initFullWindowHeight: (self) => {
		self.$element = self.$element || $(self.element);

		if (!_.isNil(self.$element.data('fullscreen')) && self.$element.data('fullscreen')) {
			let setElementHeight = () => {
				let $tplHeader = $('.siteHeader');
				let headerHeight = 0;

				if ($tplHeader.length > 0) {
					headerHeight = $tplHeader.height();
				}

				// Slight delay
				setTimeout(() => {
					self.$element.css({
						minHeight: `${$(window).height() - headerHeight}px`,
						visibility: 'visible',
					});
				}, 250);
			};

			$(window).resize(_.debounce(() => {
				setElementHeight();
			}, 250));

			setElementHeight();
		} else {
			// Slight delay
			setTimeout(() => {
				self.$element.css({
					visibility: 'visible',
				});
			}, 250);
		}
	},
};

export let compactViewMixin = {
	initCompactView: (self, classes) => {
		let minimumHeight = 550; // 550px was the chosen number to have compact views
		self.$element = self.$element || $(self.element);
		self.$tplScroller = self.$tplScroller || $(document.body);
		classes = classes || [];

		if (self.$tplScroller && self.$tplScroller.length > 0) {
			let applyCompactView = () => {
				self.$element.attr('compact-view', 'true');

				if (classes.length > 0) {
					classes.forEach((classItem) => {
						self.$element.find(classItem).attr('compact-view', true);
					});
				}
			};

			let unapplyCompactView = () => {
				self.$element.removeAttr('compact-view');

				if (classes.length > 0) {
					classes.forEach((classItem) => {
						self.$element.find(classItem).removeAttr('compact-view');
					});
				}
			};

			let isBlockExceedingHeight = () => {
				return self.$tplScroller[0].clientHeight <= minimumHeight ||
					((self.$element.outerHeight() > minimumHeight) && self.$element.outerHeight() > self.$tplScroller[0].clientHeight);
			};

			let toggleCompactViewAttribute = () => {
				if (isBlockExceedingHeight()) {
					applyCompactView();

					// Re-render
					setTimeout(() => {
						if (isBlockExceedingHeight()) {
							applyCompactView();
						}
					}, 500);
				} else {
					unapplyCompactView();
				}
			};

			$(window).resize(_.debounce(() => {
				toggleCompactViewAttribute();
			}, 250));

			toggleCompactViewAttribute();
		}
	},
};

export let trackingItemsMixinBlock = {
	initTrackingItems: (self, $items) => {
		self.$element = self.$element || $(self.element);

		let trackingId = self.$element.data('trackingId');
		if (!_.isNil(trackingId) && trackingId !== '') {
			let $tracker = $('[data-pg][data-tracker="true"]');

			if (!($tracker && $tracker.length > 0)) {
				console.error('TrackingItemsMixinBlock::Error', 'Please ensure that the [data-pg][data-tracker="true"] element exists');
				return;
			}

			if (!($items && $items.length > 0)) {
				console.error('TrackingItemsMixinBlock::Error', 'Please supply jQuery object for the list of clickable items');
				return;
			}

			$items.each((index, element) => {
				let $element = $(element);
				$element.attr('data-tracking-item-id', index);
				$element.attr('data-tracking-item-complete', false);
			});

			let activeItems = [];

			$items.on('click', (event) => {
				let $element = $(event.currentTarget);
				let trackingItemId = $element.data('trackingItemId'); // TrackingItem of the item inside the block

				// If the item is active
				let isFound = _.find(activeItems, (item) => {
					return item === trackingItemId;
				});
				if (!isFound) {
					activeItems.push(trackingItemId);
					$element.attr('data-tracking-item-complete', true); // Mark item as complete

					if ($items.length === activeItems.length) {
						$tracker.trigger('tracking.complete', {
							$element: self.$element,
							trackingId: trackingId,
						});
						self.$element.data('trackingComplete', true);
					}
				}
			});
		}
	},
};
